import { Component, ElementRef, HostListener, OnInit, ViewChild } from '@angular/core';
import { AuthService } from '../../services/auth.service';
import { SnotifyService } from 'ng-snotify';
import { Router } from '@angular/router';
import { EquipmentService } from '../../services/equipment.service';
import { WebcamImage, WebcamInitError, WebcamUtil } from 'ngx-webcam';
import { Observable, Subject } from 'rxjs';
import SignaturePad from 'signature_pad';
import * as moment from 'moment';
import { v4 as uuidv4 } from 'uuid';

@Component({
  selector: 'app-compliance',
  templateUrl: './compliance.component.html',
  styleUrls: ['./compliance.component.scss']
})
export class ComplianceComponent implements OnInit {
  @ViewChild('canvas', { static: true }) signaturePadElement;

  scannedQR: string = ""
  equipment: any;
  questions: any;
  width: any;
  height: any;

  finished: boolean = false;
  loading: boolean = false;
  loadingEquipment: boolean = false;
  saving: boolean = false;
  safeguardstyle: boolean = true;
  step: number = 0;
  headerMessage: string = '';
  currentQuestion: any;
  fileName: string = '';
  base64: any;
  takingPicture: boolean = false;
  allowCameraSwitch = true;
  multipleWebcamsAvailable = false;
  videoOptions: MediaTrackConstraints = {};
  private trigger: Subject<void> = new Subject<void>();
  private nextWebcam: Subject<boolean | string> = new Subject<boolean | string>();
  signaturePad: any;
  canvasWidth: number;
  canvasHeight: number;
  weeklyInspection: any;
  locations: any;
  translations: any[];
  selectedTranslations: any[];
  gps: string = '';
  languages = [
    { language: "English", abr: "eng" },
    { language: "Shqip", abr: "alb" },
    { language: "Eesti", abr: "est" },
    { language: "Suomi", abr: "fin" },
    { language: "Românește", abr: "rom" },
  ];
  selectedlanguage: string;
  constructor(public router: Router, private snotifyService: SnotifyService, public equipmentService: EquipmentService, private elementRef: ElementRef
  ) {
    this.weeklyInspection = {
      engineer: '',
      questions: [],
      StartTime: moment().format("yyyy-MM-DD HH:mm:ss")
    }
    var data = localStorage.getItem('selectedlanguage');
        console.log("localStorage.getItem('selectedlanguage')");
        console.log(data);

    if (data) {
      this.selectedlanguage = data;
    } else{
      this.selectedlanguage = "eng";
    }

  }
  changeLanguage(option) {
    console.log("changeLanguage");
    console.log(option);
    this.selectedlanguage = option;
    localStorage.setItem('selectedlanguage', this.selectedlanguage);
  }
  openFilePicker(id) {
    var el = document.getElementById('filePickerPopup' + id);
    el?.click();
  }

  ngOnInit(): void {
    this.loadingEquipment = true;
    this.scannedQR = this.router.parseUrl(this.router.url).queryParams["Id"];
    if(this.scannedQR == undefined)
      this.scannedQR = this.router.parseUrl(this.router.url).queryParams["id"];
    console.log(window.location.hostname);
    //console.log(this.scannedQR);
    this.equipmentService.getByQR(this.scannedQR).then((data) => {
      console.log(data);
      this.equipment = data.equipment;
      this.questions = data.questions;
      this.locations = data.locations;
      this.translations = data.translations;
      this.weeklyInspection.LocationID = this.equipment.CustAcctLocationID;
      this.currentQuestion = this.questions[0];
   
      this.onResize();
      this.tryToInitialiseSignaturePad();

      this.getCurrentLocation();
      this.updatetranslations();
      this.loadingEquipment = false;

    }, (err) => {
         this.snotifyService.error(this.getTranslation('TOAST-ERROR', this.selectedlanguage));
      //this.snotifyService.error("A error occured with loading this QR");
      //console.log(err);
      this.onResize();

      this.loadingEquipment = false;

    });
  }

  updatetranslations(){
    this.selectedTranslations = this.translations.filter(c=> {return this.selectedlanguage == null || c.Lang == this.selectedlanguage });
    // for(var i = 0; i < this.)
    // window.location.reload();
  }

  getTranslation(key, lang){
    var v = this.selectedTranslations.find(c=> c.Key == key);
    return v == null ? key :  v.Value;
  }
  handleInitError(event){
    console.log(event);
    this.snotifyService.error(event.message);
  }
  tryToInitialiseSignaturePad() {
    var canvas: any = this.elementRef.nativeElement.querySelector('canvas');
    //console.log(canvas);
    if (canvas != null) {
      canvas.width = this.width;
      if (this.signaturePad) {
        this.signaturePad.clear(); // Clear the pad on init
      }
      this.signaturePad = new SignaturePad(canvas);
      this.signaturePad.penColor = 'rgb(0, 0, 0)';
      this.clearSignature();
    }
  }
  clearSignature() {
    this.signaturePad.clear();
  }
  undoSignature() {
    var data = this.signaturePad.toData();
    if (data) {
      data.pop(); // remove the last dot or line
      this.signaturePad.fromData(data);
    }
  }
  public ngAfterViewInit(): void {
    if (this.signaturePadElement != null) {
      this.signaturePad = new SignaturePad(this.signaturePadElement.nativeElement);
      this.signaturePad.clear();
      this.signaturePad.penColor = 'rgb(0, 0, 0)';
    }

  }
  responseChanged(question, response) {
    question.ResponseID = response.ResponseID;
    question.selectedResponse = response;
    console.log(question);
  }

  next(question) {
    if (this.validateResponse(question)) {
      this.step++;

      this.currentQuestion = this.questions[this.step];
      setTimeout(() => {
        // Code to run later goes here.
        this.tryToInitialiseSignaturePad();
      }, 200); // Time till execution, in milliseconds.
    }

  }

  back() {
    this.step--;
    this.currentQuestion = this.questions[this.step];
  }

  takePicture(question) {
    this.currentQuestion = question;
    this.takingPicture = true;
  }

  public handleImageTaken(webcamImage: WebcamImage): void {
    this.currentQuestion.image = webcamImage.imageAsDataUrl;
    this.takingPicture = false;
  }

  cancelPhoto() {
    this.takingPicture = false;

  }
  public cameraWasSwitched(deviceId: string): void {

  }

  public get triggerObservable(): Observable<void> {
    return this.trigger.asObservable();
  }

  public get nextWebcamObservable(): Observable<boolean | string> {
    return this.nextWebcam.asObservable();
  }
  public triggerSnapshot(): void {
    this.trigger.next();
  }

  getCurrentLocation() {
    if (navigator.geolocation) {
     navigator.geolocation.getCurrentPosition(this.showPosition);

    } else {
      console.log("GPS Not allowed");
    }
  }
  showPosition = (position) => {
    this.gps = position.coords.latitude + "," + position.coords.longitude;
  }

  changeListener(question,e): void {
    var rawBase64 = null;
    var base64 = null;
    // If a file was selected
    if (e.target.files.length > 0) {
      this.fileName = e.target.files[0].name;

      let file = e.target.files[0];
      var reader = new FileReader();

      reader.readAsDataURL(file);

      // Split the initial data type string from the base64 data
      reader.onload = (e) => {
        rawBase64 = reader.result;
        base64 = rawBase64.split(",", 2);

        question.image = rawBase64;
      };
      reader.onerror = function (error) {
        ////console.log('Error: ', error);
      };
    }
  }
  @HostListener('window:resize', ['$event'])
  onResize(event?: Event) {
    const win = !!event ? (event.target as Window) : window;
    this.width = win.innerWidth > 11 ? (win.innerWidth - 20) : 10;

  }
switchmode(){
  this.safeguardstyle = !this.safeguardstyle;
}

  saveSignature() {
    var img = this.signaturePad.toDataURL('image/png');
    var index = img.indexOf(",") + 1;
    img = img.substring(index);


    img.replace('data:image/png;base64,', '');
    // //console.log(img);
    return img;
  }

  isCanvasBlank(): boolean {
    //console.log("Checking if blank");
    if (this.signaturePad) {
      return this.signaturePad.isEmpty() ? true : false;
    }
  }

  saveInspection() {
    if (this.isCanvasBlank()) {
      this.snotifyService.error(this.getTranslation('TOAST-SIGN', this.selectedlanguage));
      // this.snotifyService.error('Please sign to confirm');
      return;
    }

    if (this.weeklyInspection.engineer == undefined || this.weeklyInspection.engineer == null || this.weeklyInspection.engineer == 0) {
        this.snotifyService.error(this.getTranslation('TOAST-NAME', this.selectedlanguage));
      //this.snotifyService.error('Please enter your name');
      return;
    }

    if (this.weeklyInspection.LocationID == undefined || this.weeklyInspection.LocationID == null || this.weeklyInspection.LocationID == 0) {
        this.snotifyService.error(this.getTranslation('TOAST-CONTRACTOR', this.selectedlanguage));
      //this.snotifyService.error('Please select the contractor name');
      return;
    }
    this.saving = true;


    this.weeklyInspection.Ans_QS_Id = uuidv4();
    this.weeklyInspection.FinishTime = moment().format("yyyy-MM-DD HH:mm:ss");
    this.weeklyInspection.GA3UserID = 0;

    this.weeklyInspection.EquipmentID = this.equipment.EquipmentId;
    this.weeklyInspection.NextInspectionDate = moment().format("yyyy-MM-DD HH:mm:ss");

    var failed = false;
    var hasIssue = false;
    for (var i = 0; i < this.questions.length; i++) {
      var question = this.questions[i];
      question.AQS_ID = this.weeklyInspection.Ans_QS_Id;
      question.AnsQuestionID = uuidv4();

      if (question.FreeTextOrDropdown == 0) {
        if ((question.selectedResponse.ResponseValueID == 0 || question.selectedResponse.ResponseValue == 'Negative')) {
          failed = true;
        }
        if ((question.selectedResponse.ResponseFreeText == '' || question.selectedResponse.ResponseValue == 'Negative')) {
          hasIssue = true;
        }
      }

    }

    this.weeklyInspection.HasFailed = failed;
    this.weeklyInspection.UpdateTime = moment().format("yyyy-MM-DD HH:mm:ss");
    this.weeklyInspection.AutoEmail_Sent = false;
    this.weeklyInspection.GPS = this.gps;
    this.weeklyInspection.HasIssue = hasIssue;
    this.weeklyInspection.GA3UserSignature = this.saveSignature();
    this.weeklyInspection.questions = this.questions;


    console.log(this.weeklyInspection);
    this.equipmentService.postComplianceInspection(this.weeklyInspection).then((data) => {
        this.snotifyService.success(this.getTranslation('TOAST-SUCCESS', this.selectedlanguage));
      // this.snotifyService.success("successfully saved Compliance Report.");

      setTimeout(() => {
        this.finished = true;
        this.saving = false;;
        // Code to run later goes here
        window.self.close();
        window.top.close();

      }, 1000); // Time till execution, in milliseconds.


    }, (err) => {
      this.snotifyService.error(err.error);
      //console.log(err);
    })
  }

  onLocationChange(location) {
    //console.log(location);
    this.weeklyInspection.LocationID = location.LocationID;
    this.weeklyInspection.CompanyID = location.CompanyID;
  }


  validateResponse(question) {
    // //console.log("validating");
    var valid = true;
    //console.log(question);
    if (question.selectedResponse != null && question.selectedResponse.ResponseValueID == 0) {
      if (question.ResponseFreeText == null || question.ResponseFreeText == undefined) {
          this.snotifyService.error(this.getTranslation('TOAST-COMMENT', this.selectedlanguage));
      // this.snotifyService.error("Please enter a comment for this question");
        valid = false;
      }
      if (question.image == null || question.image == undefined) {
           this.snotifyService.error(this.getTranslation('TOAST-PICTURE', this.selectedlanguage));
      //this.snotifyService.error("Please select or take a picture for this question");
        valid = false;
      }
    }
    if (question.ResponseID < 0 && question.FreeTextOrDropdown <= 0) {
      //console.log("no response");
         this.snotifyService.error(this.getTranslation('TOAST-RESPONSE', this.selectedlanguage));
      //this.snotifyService.error("Please select a response for this question");
      valid = false;
    }
    // //console.log(valid);

    return valid;
  }
}
